import api from "../../api";
import {promptData} from "../../util/MessageTools";
import {gameItemEnumToString} from "../../util/EnumTransition";
import router from "../../router";
import {disposeResult} from '../../util/DisposeResult'
import {downFile} from "../../util/DownFile";

export default {
  name: "thesisAllot",
  data() {
    return {
      data: [],
      teachers: [],//分配的老师
      thesisAllotOptions: [{
        value: 0,
        label: "未分配"
      }, {
        value: 1,
        label: "已分配"
      }],//老师的集合
      teacherOptions: [],
      addTeacherDialog: false,//添加老师的弹出框
      currentRow: "",//选中行的信息
      thesisAllotStatus: 0,
      oneColumn: false,
      twoColumn: false,
      threeColumn: false,
      educationList:[
        {
          value: 'NOT_APPLICABLE',
          label: '全部'
        }, {
          value: 'UNDERGRADE',
          label: '本科生'
        }, {
          value: 'MASTER',
          label: '研究生'
        },
      ],
      teamGrade: 'NOT_APPLICABLE',//学历筛选条件
      tableLoading:false,
    }
  },
  methods: {

    /**
     * 隐藏列
     */
    hideColumn() {
      this.oneColumn = false
      this.twoColumn = false
      this.threeColumn = false
    },

    /**
     * 改变时
     * @param
     */
    onchange() {
      if (this.thesisAllotStatus === 0) {
        this.getAllNotFinaledAndNotSpecifyedList()
      } else if (this.thesisAllotStatus === 1) {
        this.getAllNotFinaledAndSpecifyedList()
      }
    },

    /**
     * 添加审核老师
     * @param row 当前行信息
     */
    addTeacher(row) {
      this.teachers = ""
      this.currentRow = row
      let vue = this
      vue.teacherOptions = []
      api.user.getUserList("REFEREE").then(function (response) {
        if (response == null) {
          return
        }
        if (response.data.code === "0") {
          vue.addTeacherDialog = true
          let result = response.data.result
          for (let i = 0; i < result.length; i++) {
            let obj = {}
            obj.value = result[i].id
            obj.label = result[i].trueName
            vue.teacherOptions.push(obj)
          }
        }
      })
    },

    /**
     * 保存审核老师
     */
    saveTeacher() {
      let vue = this
      if (this.teachers.length === 0) {
        promptData("请选择一名审核老师", this)
        return
      }
      let ids = ""
      let texts = ""
      for (let i = 0; i < this.teachers.length; i++) {
        if (i === this.teachers.length - 1) {
          ids += this.teachers[i]
        } else {
          ids += this.teachers[i] + ","
        }
        for (let j = 0; j < this.teacherOptions.length; j++) {
          if (this.teachers[i] === this.teacherOptions[j].value) {
            texts += this.teacherOptions[j].label + ","
            continue
          }
        }
      }
      texts = texts.substring(0, texts.length - 1)
      let thesisId = this.currentRow.id
      api.contribute.specifyReferee(thesisId, ids).then(function (response) {
        if (response == null) {
          return null
        }
        if (response.data.code === "0") {
          vue.teachers = []
          vue.addTeacherDialog = false
          if (vue.thesisAllotStatus === 0) {
            for (let i = 0; i < vue.data.length; i++) {
              if (vue.data[i].id === thesisId) {
                vue.data.splice(i, 1)
                break
              }
            }
          } else {
            for (let k = 0; k < vue.data.length; k++) {
              if (vue.data[k].id === thesisId) {
                vue.data[k].refereeTrueName = texts
                vue.data = JSON.parse(JSON.stringify(vue.data))
                break
              }
            }
          }
        }
      })
    },

    /**
     * 管理员查询当前轮数未终审且未分配过审核人的论文
     */
    getAllNotFinaledAndNotSpecifyedList() {
      let vue = this
      vue.tableLoading = true
      api.contribute.getAllNotFinaledAndNotSpecifyedList(this.teamGrade).then(function (response) {
        vue.tableLoading = false
        if (response == null) {
          return null
        }
        if (response.data.code === "0") {
          let result = response.data.result
          /* for (let i = 0; i < result.length; i++) {
             let currentData = []
             let refereeTrueName = ""
             for (let j = 0; j < result[i].refereeOpinionVos.length; j++) {
               if (result[i].refereeOpinionVos[j].roundNo === curRound) {
                 currentData.push(result[i].refereeOpinionVos[j])
               }
             }
             for (let p = 0; p < currentData.length; p++) {
               if (p === currentData.length - 1) {
                 refereeTrueName += currentData[p].refereeTrueName
               } else {
                 refereeTrueName += currentData[p].refereeTrueName + ","
               }
             }
             result[i].refereeTrueName = refereeTrueName
           }*/

          vue.data = disposeResult(result, vue)
        }
      }).catch(err=>{
        vue.tableLoading = false
      })
    },

    /**
     * 管理员查询当前轮数未终审且已分配过审核人的论文
     * @return List<ThesisVo>
     */
    getAllNotFinaledAndSpecifyedList() {
      let vue = this
      vue.tableLoading = true
      api.contribute.getAllNotFinaledAndSpecifyedList(this.teamGrade).then(function (response) {
        vue.tableLoading = false
        if (response == null) {
          return null
        }
        if (response.data.code === "0") {
          let result = response.data.result
          vue.data = disposeResult(result, vue)
        }
      }).catch(err=>{
        vue.tableLoading = false
      })
    },


    /**
     * 查看阶段的论文信息
     * @param row
     */
    viewWordData(row) {
      let number = router.app.$options.store.state.curRound
      let id = ""
      let fileName = row.teamName + "-"
      switch (number) {
        case 1:
          id = row.abstractFileName//1阶段
          fileName += row.abstractOriginalName
          break
        case 2:
          id = row.briefFileName//2阶段
          fileName += row.briefOriginalName
          break
        case 3:
          id = row.bodyFileName//三阶段
          fileName += row.bodyOriginalName
          break
      }
      let vue = this
      this.isActive = true
      api.contribute.getWorksOfManager(id).then(function (response) {
        if (response == null) {
          return null
        }
        downFile(response, fileName, vue)
      })

    },

  },

  created() {
    this.getAllNotFinaledAndNotSpecifyedList(this.teamGrade)
  }
}



// WEBPACK FOOTER //
// ./src/js/Admin/ThesisAllot.js